import type { StockListResponseType } from "@sellar-io/api-v2/types";

export const generateCategoryName = (
  category?: Pick<StockListResponseType[number], "name" | "kind" | "abv">,
  removeName?: boolean,
): string =>
  [
    !removeName && category?.name,
    category?.kind,
    !!(category?.abv || category?.abv === 0) && `${category.abv}%`,
  ]
    .filter(Boolean)
    .join(" // ");
